import { healthEffect } from "../../classes/types/class-user.types";
import { getPlayerSessionId } from "../../helpers";

async function sendChangePlayerHitpointsRequest(amount: number, effect: healthEffect): Promise<boolean> {
    try {
        const response: Response = await fetch(`${viteConfiguration.API_URL}player/hitpoints/change`, {
            method: "post",
            headers: {
                "Content-Type": "application/json",
                "X-PlayerSessionId": getPlayerSessionId(),
            },
            body: JSON.stringify({ amount, effect }),
        });

        const result: any = await response.json();

        console.log(result);

        if (!result) {
            return false;
        }

        return true;
    } catch (error) {
        console.error(error);
    }
    return false;
}

export default sendChangePlayerHitpointsRequest;
